import request from "@/utils/request";
 
export function login(data) {
    return request({
        method: 'post',
        url: '/sell/login/sellLogin',
        data: data 
    })
}